'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function generateId() {
  const mid = Math.trunc(Math.random() * 16777215);
  const pid = Math.trunc(Math.random() * 65535);
  let cnt = Math.trunc(Math.random() * 16777215);
  const hex = (num, size) => {
    return ("00000000" + num.toString(16)).substr(-size);
  };
  const sec = Math.trunc(Date.now() / 1e3);
  if (cnt > 16777215) {
    cnt = Math.trunc(Math.random() * 16777215);
  } else {
    cnt++;
  }
  return hex(sec, 8) + hex(mid, 6) + hex(pid, 4) + hex(cnt, 6);
}

exports.generateId = generateId;
